<div class="advanced-settings">
  <div class="content">
    <div class="tabs-setting">
      <a routerLink="/advanced-settings/super-seller" routerLinkActive="active">overview</a>
      <a routerLink="/advanced-settings/super-seller-setting" routerLinkActive="active">edit</a>
    </div>
    <ng-container *ngIf="userInfo?.level < 5">
      <div class="not-allowed">You have to be level 5 and above to access this feature</div>
    </ng-container>
    <div class="content__title">Exclusive Features for Super Sellers</div>
    <div class="content__box">
      <label *ngFor="let option of superSellerFeatures" class="toggle" for="buyerContact">
        <input type="checkbox" name="buyerContact" [value]="false" [disabled]="true" class="toggle__input" id="buyerContact" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z"></path>
              </svg>
            </span>
          </span>
        </span>
        {{ option }}
      </label>

      <label class="toggle" for="allowBookDriver">
        <input type="checkbox" name="allowBookDriver" [(ngModel)]="userInfo.allowBookDriver" class="toggle__input" id="allowBookDriver" />
        <span class="toggle-track">
          <span class="toggle-indicator">
            <span class="checkMark">
              <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                <path d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z"></path>
              </svg>
            </span>
          </span>
        </span>
        Allow Driver Bookings
      </label>
    </div>
  </div>
</div>
